import React from 'react';

import { DateTime } from 'luxon';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { reportActionCreators } from '../../../../../../redux/ducks/playersAndTeams/report';
import { InputSeparator, TimeSelectContainer } from '../../styles';

import { DateSelect } from './styles';

const MIN_DATE = DateTime.fromISO('1917-12-19');

const CalendarSelects = () => {
    const dispatch = useDispatch();
    const intl = useIntl();

    const dateFrom = useSelector((state) => state.playersAndTeams.report.current.dateFrom);
    const dateTo = useSelector((state) => state.playersAndTeams.report.current.dateTo);

    const selectedDateFrom = DateTime.fromISO(dateFrom);
    const selectedDateTo = DateTime.fromISO(dateTo);

    const onDateFromChange = (newFromDate) => {
        if (newFromDate !== selectedDateFrom) {
            dispatch(reportActionCreators.setDateFrom(newFromDate.toISODate()));
            dispatch(reportActionCreators.runReport());
        }
    };

    const onDateToChange = (newToDate) => {
        if (newToDate !== selectedDateTo) {
            dispatch(reportActionCreators.setDateTo(newToDate.toISODate()));
            dispatch(reportActionCreators.runReport());
        }
    };

    const handleDateFromArrowClick = (previousDate) => {
        dispatch(reportActionCreators.setDateFrom(selectedDateFrom.plus({ days: previousDate ? -1 : 1 }).toISODate()));
        dispatch(reportActionCreators.runReport());
    };

    const handleDateToArrowClick = (previousDate) => {
        dispatch(reportActionCreators.setDateTo(selectedDateTo.plus({ days: previousDate ? -1 : 1 }).toISODate()));
        dispatch(reportActionCreators.runReport());
    };

    const dateDisplay = (date) => (date !== undefined ? date.toLocaleString(DateTime.DATE_MED) : '');

    return (
        <TimeSelectContainer>
            <DateSelect
                dateDisplay={dateDisplay}
                calendarMaxDate={selectedDateTo}
                calendarMinDate={MIN_DATE}
                intl={intl}
                localeCode={window.__SITE_LANGUAGE_CODE__}
                onArrowClick={handleDateFromArrowClick}
                onSelectDate={onDateFromChange}
                selectedDate={selectedDateFrom}
            />
            <InputSeparator>-</InputSeparator>
            <DateSelect
                dateDisplay={dateDisplay}
                calendarMaxDate={DateTime.now()}
                calendarMinDate={selectedDateFrom}
                intl={intl}
                localeCode={window.__SITE_LANGUAGE_CODE__}
                onArrowClick={handleDateToArrowClick}
                onSelectDate={onDateToChange}
                selectedDate={selectedDateTo}
            />
        </TimeSelectContainer>
    );
};

export default React.memo(CalendarSelects);
